function generateAutocomplete(searchInput, hiddenInput = null, data) {
    let input = document.getElementById(searchInput);
    if (input) {
        if (document.querySelector(".data-tracking-tab.active")) {
            const search_input = document.getElementById("searchInput");
            const tab = document
                .querySelector(".data-tracking-tab.active")
                .getAttribute("id");

            let placeholder =
                "Busca asociaciones por nombre, domicilio o folio del trámite";

            switch (tab) {
                case "contratos-tab":
                    placeholder =
                        "Busca contratos por número de expediente, domicilio o folio del trámite";
                    break;
                case "historicos-tab":
                    placeholder =
                        "Busca contratos por número de expediente, domicilio o folio del trámite";
                    break;
                case "reglamentos-tab":
                    placeholder =
                        "Busca reglamentos por número de registro, domicilio o folio del trámite";
                    break;
            }

            search_input.setAttribute("placeholder", placeholder);
            search_input.setAttribute("title", placeholder);
        }

        input.addEventListener("focusout", function () {
            if (input.value.length === 0) {
                if (hiddenInput != null) {
                    document.getElementById(hiddenInput).value = null;
                    document
                        .getElementById(hiddenInput)
                        .dispatchEvent(new Event("change"));
                }
            }
        });
        autocomplete({
            input: input,
            emptyMsg: "Sin resultados",
            minLength: 1,
            disableAutoSelect: true,
            fetch: function (text, update) {
                text = text.toLowerCase();
                // you can also use AJAX requests instead of preloaded data
                var suggestions = data.filter((n) =>
                    n.label.toLowerCase().includes(text)
                );
                update(suggestions);
            },
            onSelect: function (item) {
                let label = item.label;
                if (label.includes(" - ")) {
                    const words = label.split(" - ");
                    label = words[1];
                }
                input.value = label;
                if (hiddenInput != null) {
                    let hidden = document.getElementById(hiddenInput);
                    if (hidden) {
                        hidden.value = label;
                        hidden.dispatchEvent(new Event("change"));
                    }
                }
            },
        });
    }
}

window.addEventListener("tab-updated", (event) => {
    if (typeof autoridades !== "undefined")
        generateAutocomplete("ac_autoridad", "autoridad_origen", autoridades);
    if (typeof ramas !== "undefined")
        generateAutocomplete("ac_rama_industrial", "rama_industrial", ramas);
    buscadorMiembros();
    validacionesInputs();
});

window.addEventListener("load", function (event) {});
isNumber = function (evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31) return !isNaN(evt.key);
};

buscadorMiembros = function () {
    var ac_miembro = document.getElementById("ac_nombre_miembro");
    var i_miembro = document.getElementById("nombre_miembro");
    miembros = [];
    if (ac_miembro) {
        ac_miembro.addEventListener("focusout", function () {
            if (ac_miembro.value.length === 0) {
                i_miembro.value = null;
                i_miembro.dispatchEvent(new Event("change"));
            }
        });
        autocomplete({
            input: ac_miembro,
            emptyMsg: "Sin resultados",
            minLength: 1,
            disableAutoSelect: true,
            debounceWaitMs: 200,
            fetch: function (text, update) {
                text = text.toLowerCase();
                var suggestions = miembros.filter((n) =>
                    n.label.toLowerCase().includes(text)
                );
                update(suggestions);
            },
            onSelect: function (item) {
                let label = item.label;
                if (label.includes(" - ")) {
                    const words = label.split(" - ");
                    label = words[1];
                }
                ac_miembro.value = label;
                if (i_miembro) {
                    i_miembro.value = label;
                    i_miembro.dispatchEvent(new Event("change"));
                }
            },
        });
    }
};

if (typeof autoridades !== "undefined")
    generateAutocomplete("ac_autoridad", "autoridad_origen", autoridades);
if (typeof ramas !== "undefined")
    generateAutocomplete("ac_rama_industrial", "rama_industrial", ramas);

if (typeof autoridades !== "undefined")
    generateAutocomplete(
        "input_autoridad_origen",
        "hdn_autoridad_origen",
        autoridades
    );
if (typeof ramas !== "undefined")
    generateAutocomplete("input_rama_industrial", "hdn_rama_industrial", ramas);

buscadorMiembros();

searchMiembro = function (e) {
    axios
        .post(base_url + "/busquedaMiembros", {
            q: e.value,
        })
        .then((response) => {
            let data = response.data;
            if (data.success) {
                miembros = data.miembros;
                //miembro.dispatchEvent(new Event('keyup'));
            }
        })
        .catch((e) => {
            console.error(e);
        });
};

resetForm = function (form, reset) {
    document.getElementById(reset).value = 1;
    document.getElementById(form).submit();
};

const searchInput = document.getElementById("searchInput");

if (searchInput) {
    searchInput.addEventListener("search", (e) => {
        document.getElementById("form_busqueda").submit();
    });
}

validacionesInputs = function () {
    const folio = document.getElementById("folio");
    const persona = document.getElementById("nombre_persona");
    const cp = document.getElementById("domicilio_cp");
    const municipio = document.getElementById("municipio_alcaldia");
    const colonia = document.getElementById("colonia");
    if (folio)
        folio.addEventListener("input", function (event) {
            if (folio.validity.tooShort)
                folio.setCustomValidity(
                    "Favor de escribir un folio válido. Ejemplo: CFCRL-ASOCIACION-20210703-3389-0085"
                );
            else folio.setCustomValidity("");
        });
    if (persona)
        persona.addEventListener("input", function (event) {
            if (persona.validity.tooShort)
                persona.setCustomValidity(
                    "Favor de escribir al menos 3 letras para realizar la búsqueda (actualmente " +
                        persona.value.length +
                        ")"
                );
            else persona.setCustomValidity("");
        });
    if (cp)
        cp.addEventListener("input", function (event) {
            if (cp.validity.tooShort)
                cp.setCustomValidity(
                    "Favor de escribir 5 dígitos para el CP (actualmente " +
                        cp.value.length +
                        ")"
                );
            else cp.setCustomValidity("");
        });
    if (municipio)
        municipio.addEventListener("input", function (event) {
            if (municipio.validity.tooShort)
                municipio.setCustomValidity(
                    "Favor de escribir al menos 3 letras para realizar la búsqueda (actualmente " +
                        municipio.value.length +
                        ")"
                );
            else municipio.setCustomValidity("");
        });
    if (colonia)
        colonia.addEventListener("input", function (event) {
            if (colonia.validity.tooShort)
                colonia.setCustomValidity(
                    "Favor de escribir al menos 3 letras para realizar la búsqueda (actualmente " +
                        colonia.value.length +
                        ")"
                );
            else colonia.setCustomValidity("");
        });
};

validacionesInputs();

if (document.getElementById("fecha_registro")) {
    new DateRangePicker("fecha_registro");
    new DateRangePicker("fecha_actualizacion");
}
